import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";
import { Eye, EyeOff } from "lucide-react";

export default function EditarPerfil() {
  const { token, user } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    dni: "",
    nombre: "",
    apellidos: "",
    email_usuario: "",
    telefono_usuario: "",
    password: "",
    password_confirmation: "",
  });

  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      if (!token || !user) return;
      try {
        const { data } = await api.get(`/usuarios/${user.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setFormData({
          dni: data.dni || "",
          nombre: data.nombre || "",
          apellidos: data.apellidos || "",
          email_usuario: data.email || "",
          telefono_usuario: data.telefono || "",
          password: "",
          password_confirmation: "",
        });
        setLoading(false);
      } catch {
        setMessage("No se pudo cargar el perfil");
        setLoading(false);
      }
    };
    fetchUser();
  }, [token, user]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      const payload = { ...formData };
      if (!payload.password) {
        delete payload.password;
        delete payload.password_confirmation;
      }
      await api.put(`/usuarios/${user.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage("Perfil actualizado correctamente");
      setFormData({ ...formData, password: "", password_confirmation: "" });
    } catch (error) {
      setMessage(error.response?.data?.message || "Error al actualizar perfil");
    }
  };

  if (loading) return <p className="text-center mt-5">Cargando perfil...</p>;

  return (
    <div className="container fluid">
        <h1 className="fs-3 fw-bold">Editar perfil</h1>
        <div className="mt-3">
          {message && (
            <div
              className="alert py-2 px-3"
              style={{
                backgroundColor: "#FFF4E6",
                color: "#FF7A00",
                border: "1px solid #FFB366",
                fontSize: "0.95rem",
              }}
            >
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">DNI</label>
                <input
                  type="text"
                  name="dni"
                  className="form-control"
                  value={formData.dni}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Nombre</label>
                <input
                  type="text"
                  name="nombre"
                  className="form-control"
                  value={formData.nombre}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Apellidos</label>
                <input
                  type="text"
                  name="apellidos"
                  className="form-control"
                  value={formData.apellidos}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email_usuario"
                  className="form-control"
                  value={formData.email_usuario}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Teléfono</label>
                <input
                  type="text"
                  name="telefono_usuario"
                  className="form-control"
                  value={formData.telefono_usuario}
                  onChange={handleChange}
                  style={{ borderColor: "#FF7A00" }}
                />
              </div>

              <div className="col-md-6 position-relative">
                <label className="form-label">Contraseña (opcional)</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-control pe-5"
                    value={formData.password}
                    onChange={handleChange}
                    style={{ borderColor: "#FF7A00" }}
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y me-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </span>
                </div>  
              </div>

              <div className="col-md-6 position-relative">
                <label className="form-label">Confirmar Contraseña</label>
                <div className="input-group">

                  <input
                    type={showPasswordConfirm ? "text" : "password"}
                    name="password_confirmation"
                    className="form-control pe-5"
                    value={formData.password_confirmation}
                    onChange={handleChange}
                    style={{ borderColor: "#FF7A00" }}
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y me-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                  >
                    {showPasswordConfirm ? <EyeOff size={20} /> : <Eye size={20} />}
                  </span>
                </div>  
              </div>
            </div>

            <button
              type="submit"
              className="btn w-100 mt-4"
              style={{
                backgroundColor: "#FF7A00",
                color: "#fff",
                fontWeight: "600",
                fontSize: "1rem",
              }}
            >
              Guardar cambios
            </button>
          </form>
        </div>
      </div>
  );
}
